<wdx-info-card class="w-100" [flush]="true">
    <div wdxInfoCardLeading>
        @if (!hasImage && fileIndex) {
            @if ($any(fileIndex?.contentType) | fileTypeAsIcon; as fileType) {
                <wdx-icon-container
                    class="bg-icon file-type-{{ $any(fileType).fileType }}"
                    size="md"
                >
                    <wdx-icon [icon]="$any(fileType).icon"></wdx-icon>
                </wdx-icon-container>
            }
        }

        @if (hasImage) {
            @if (image) {
                <div class="avatar avatar-lg">
                    <div
                        class="avatar-image"
                        [style.background-image]="image"
                    ></div>
                </div>
            }
        }
    </div>
    <div wdxInfoCardLabel>{{ label ?? fileIndex?.name }}</div>
    <div wdxInfoCardSub>
        {{ subtitle ?? (fileIndex?.sizeInBytes | fileSize) }}
    </div>
    <div wdxInfoCardTrailing>
        <wdx-icon-button
            class="ms-2"
            size="sm"
            wdxStyle="outline-primary"
            (wdxOnClick)="downloadFile()"
            ><wdx-icon [icon]="ICON_DOWNLOAD"></wdx-icon
        ></wdx-icon-button>
        <ng-content></ng-content>
    </div>
</wdx-info-card>
